const ITEMS = [
  "Modern Websites",
  "Practical IT Support",
  "Non-Profits & NPCs",
  "Responsive Design",
  "Personalised Support",
  "South Africa",
];

function Run({ hidden }) {
  return (
    <div aria-hidden={hidden || undefined} className="flex items-center">
      {ITEMS.map((item) => (
        <span
          key={item}
          className="flex items-center font-mono text-sm uppercase tracking-[0.3em] text-white/30"
        >
          <span className="px-8">{item}</span>
          <span className="h-1 w-1 rounded-full bg-cy/50" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section
      data-testid="editorial-marquee"
      aria-label="Studio services ticker"
      className="overflow-hidden border-y hairline bg-ink2/60 py-6"
    >
      <div className="flex w-max animate-marquee">
        <Run />
        <Run hidden />
      </div>
    </section>
  );
}
